export function getParameterByName(name, url = window.location.href) {
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

export function serialize(obj) {
    var str = [];
    for (var p in obj)
        if (obj.hasOwnProperty(p)) {
            str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
        }
    return str.join("&");
}

export function redirectWizardSteps(isAgency, step, property, inertia) {
    if (step === 1) return

    let current_property_id = localStorage.getItem('current_property_id')
    let current_property = localStorage.getItem('current_property')

    if (current_property_id === null) {
        if (isAgency) {
            inertia.visit('/agency/properties')
        } else {
            inertia.visit('/wizard/customer')
        }

        return
    } else {
        if (current_property == null || current_property == 'undefined') {
            axios.get('/wizard/properties/' + current_property_id)
                .then(response => {
                    localStorage.setItem('current_property', JSON.stringify(response.data))
                })
                .catch(error => {
                    console.log(error)
                })
        }

        if (step === '2alt') return

        let current_property_parsed = JSON.parse(current_property)
        let current_step = (parseInt(current_property_parsed.wizard_step) + 1)

        if (step === current_step) return

        if (step > current_step) {
            if (isAgency) {
                inertia.visit('/wizard/' + current_step)
            } else {
                inertia.visit('/wizard/customer/' + current_step)
            }
        }
    }
}

export function numf(number) {
    return new Intl.NumberFormat("it-IT", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(number);
}
